<template>
    <div class="googleauth">
        <NavigationBar>
          <template v-slot:left>
            <img v-if="loggedIn" class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack">
            <div v-else></div>
          </template>
            <template v-slot:center>
            </template>
        </NavigationBar>
        <div>
          <p></p>
        </div>
      <!--
        <div class="input-container" style="margin-top: 20px;">
          <div class="input-infotext">
            <p>token#</p>
            <p>{{ this.token }}</p>
            <p>#token</p>
          </div>
        </div>
        <div class="input-container" style="margin-top: 20px;">
          <div class="input-infotext">
            <p>gatoken#</p>
            <p>{{ this.gatoken }}</p>
            <p>#gatoken</p>
          </div>
        </div>
        <div class="input-container" style="margin-top: 20px;">
          <div class="input-infotext">
            <p>user#</p>
            <p>{{ this.user }}</p>
            <p>email {{ this.user.email }}</p>
            <p>#user</p>
          </div>
        </div>
        <div class="input-container" style="margin-top: 20px;">
          <div class="input-infotext">
            <p>gauser#</p>
            <p>{{ this.gauser }}</p>
            <p>email {{ this.gauser.email }}</p>
            <p>#gauser</p>
          </div>
        </div>
        <div class="input-container" style="margin-top: 20px;">
          <div class="input-infotext">
            <p>restext#</p>
            <p>{{ this.restext }}</p>
            <p>#restext</p>
          </div>
        </div>
        <div class="input-container" style="margin-top: 20px;">
          <div class="input-infotext">
            <p>garestext#</p>
            <p>{{ this.garestext }}</p>
            <p>#garestext</p>
          </div>
        </div>
      -->
    </div>
</template>

<script>
  import NavigationBar from '../components/NavigationBar'
  import Vue from 'vue'
  import APIService from '@/services/APIService'
  import {
    BATTLE_COMPETITION,
    TOAST_DURATION, TYPE_BATTLE,
    TYPE_BATTLE_ID,
    TYPE_BETGAME,
    TYPE_BETGAME_ID, TYPE_TEAMS,
    TYPE_TEAMS_ID
  } from '@/main'
  import jwt_decode from 'jwt-decode'
  import moment from 'moment'
  
  export default {
    name: 'GoogleAuth',
    components: { NavigationBar },
    data() {
      return {
        token: '',
        gatoken: '',
        user: null,
        gauser: null,
        restext: '',
        garestext: ''
      }
    },
    computed: {
      loggedIn() {
        return this.$store.getters.loggedIn
      },
    },
    created () {
      this.completeGoogleAuth()
    },
    methods: {
      async completeGoogleAuth () {
        this.token = this.$route.query.token
        this.gatoken = window.localStorage.getItem('gatoken')
        const credential = this.token || this.gatoken

        if (!credential) {
          window.localStorage.setItem('betgameAction', '')
          this.$router.replace('/login')
          return
        }

        try {
          // POST /auth/google (applesignin.go googleAuthHandler):
          // - email conflict → redirect /applesignin?msg=email_already_used&external_login=google
          // - signup/login OK → JSON { fk_user, external_id, email, error }
          const result = await this.verifyTokenWithBackend(credential, this.token ? 0 : 1)

          if (result.redirected && result.url) {
            window.location.href = result.url
            return
          }

          let email = ''
          let eid = ''
          if (result.json && result.json.external_id) {
            if (result.json.error || result.json.fk_user === '0' || result.json.fk_user === 0 ||
                !result.json.email || result.json.email === 'none') {
              throw new Error(result.json.error || 'Google auth failed')
            }
            email = result.json.email
            eid = result.json.external_id
          } else {
            const user = this.parseJwt(credential)
            if (!user || !user.email || !user.sub) {
              throw new Error('Invalid Google token payload')
            }
            email = user.email
            eid = user.sub
          }

          this.user = { email: email, sub: eid }
          await this.onLoginSuccess(this.user)
        } catch (err) {
          Vue.$log.debug('GoogleAuth completeGoogleAuth failed:', err)
          window.localStorage.setItem('betgameAction', '')
          this.$router.replace('/login')
        }
      },
      getGoogleClientType () {
        // Must match applesignin.go googleAuthHandler clientid selection
        if (window.AndroidBridge && window.AndroidBridge.signInWithGoogle) {
          return 'android'
        }
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.TeamtipAppInterface) {
          return 'ios'
        }
        return 'web'
      },
      onLoginSuccess (user) {
        Vue.$log.debug('GoogleAuth onLoginSuccess: ', user.email, user.sub, user.name)
        const eid = user.sub
        const email = user.email
        if (!eid || !email || String(eid).length < 3) {
          window.localStorage.setItem('betgameAction', '')
          this.$router.replace('/login')
          return
        }
        // Same password derivation as Go: passwd := sub[1 : len(sub)-1]
        const pwd = eid.slice(1, -1)
        Vue.$log.debug('GoogleAuth mounted ' + ' --- ' + eid + ' --- ' + email)
        APIService.isEmailRegisteredExternal(email.toLowerCase().trim()).then(response => {
          if (response.data.valid === '1') {
            this.$store.dispatch('login', {
              email: String(email).toLowerCase(),
              pass: pwd
            }).then((res) => {
              Vue.$log.debug('GoogleAuth onLoginSuccess ' + JSON.stringify(this.$store.state.user))
              const bgid = this.getBGValue('spmbgid')
              const ic = this.getBGValue('spmic')
              if (ic !== undefined && ic !== null && this.isNumeric(ic) && ic > 0) {
                window.localStorage.setItem('spmic', '')
                if(this.$store.state.user && (!this.$store.state.user.source || this.$store.state.user.source === '')) {
                  this.$store.dispatch('patchUser', {
                    source: ic
                  })
                }
              } else {
                const us = window.localStorage.getItem('userSource') || ''
                if(us !== undefined && us !== null && us !== '') {
                  window.localStorage.setItem('userSource', '')
                  if(this.$store.state.user && (!this.$store.state.user.source || this.$store.state.user.source === '')) {
                    this.$store.dispatch('patchUser', {
                      source: us
                    })
                  }
                }
              }
              const betgameAction = this.getBGValue('betgameAction')
              if (betgameAction && betgameAction === 'invitation' && bgid !== undefined && bgid !== null && this.isNumeric(bgid) && bgid > 0) {
                window.localStorage.setItem('betgameAction', '')
                this.$store.dispatch('userEnterBetgame', bgid).then(() => {
                  this.$router.push('/feed/dashboard')
                })
              } else if (betgameAction && betgameAction === 'login') {
                window.localStorage.setItem('betgameAction', '')
                if (bgid !== undefined && bgid !== null && this.isNumeric(bgid) && bgid > 0) {
                  this.$store.dispatch('userEnterBetgame', bgid).then(() => {
                    this.$router.push('/feed/dashboard')
                  }) 
                } else {
                  if(this.$store.getters.loggedIn && this.$store.state.user && !this.$store.state.user.acceptedtos) {
                    window.location.href = 'https://teamtip.net/finishregistration'
                  } else {
                    window.location.href = 'https://teamtip.net/mybetgames'
                  }
                }
              } else if (betgameAction && betgameAction === 'registerUserCreateBetgame') {
                window.localStorage.setItem('betgameAction', '')
                const c = window.localStorage.getItem('createBetgame')
                const createBetgame = JSON.parse(c)
                this.$store.dispatch('createBetgame', {
                  email: email,
                  user_id: '' + this.$store.state.user.id,
                  betgame: createBetgame.betgameName.trim(),
                  competition: createBetgame.betgameType === TYPE_BETGAME ? parseInt(createBetgame.competition) : BATTLE_COMPETITION
                })
                .then(() => {
                  this.$store.dispatch('patchBetgame', {
                    bet_mode: createBetgame.betmode,
                    description: createBetgame.betgameDescription,
                    type: createBetgame.betgameType === 'battle' ? TYPE_BATTLE_ID : (createBetgame.betgameType === 'teams' ? TYPE_TEAMS_ID : TYPE_BETGAME_ID)
                  }).then(() => {
                  })
                  this.$store.dispatch('addBetgamesOwner', {
                    id: this.$store.state.betgameId,
                    name: 'Neue Tipprunde',
                    type: 'Wettbewerb'
                  })
                  if (this.$store.state.chat_token && this.$store.state.chat_token !== '') {
                    const payload = jwt_decode(JSON.stringify(this.$store.state.chat_token))
                    const a = payload.exp * 1000
                    const b = moment()
                    if (a > b) {
                      this.$store.dispatch('chatCreateConversation', {
                        'title': createBetgame.betgameName.trim(),
                        'participant_ids': ['' + id]
                      }).then(response => {

                      })
                      .catch(function(error) {

                      })
                    }
                  }
                  if (createBetgame.betgameType === TYPE_BATTLE) {
                    const sm = createBetgame.selectedMatches
                    var m = []
                    for (var key in sm) {
                      if (sm.hasOwnProperty(key)) {
                        for (var key1 in sm[key]) {
                          if (sm[key].hasOwnProperty(key1)) {
                            const v = sm[key][key1]
                            if (v === true) {
                              m.push({ fk_betgame: this.$store.state.betgameId, fk_match: parseInt(key1) })
                            }
                          }
                        }
                      }
                    }
                    const data = {
                      fk_betgame: this.$store.state.betgameId,
                      matches: m
                    }
                    this.$store.dispatch('saveBetgameMatches', data).then(response => {
                      if (response.status >= 200 && response.status <= 204) {
                        this.$store.dispatch('clearSelectedMatches', {}).then(() => {
                        })
                      }
                    }, error => {

                    })
                  } else if (createBetgame.betgameType === TYPE_TEAMS) {
                    const sc = createBetgame.selectedCompetitions
                    const stc = createBetgame.selectedTeamsCompetitions
                    const data = []
                    for (var i = 0; i < sc.length; i++) {
                      const t = stc.filter(x => x.bg_competition.id === sc[i])
                      if (t) {
                        for (var j = 0; j < t.length; j++) {
                          const d = {
                            fk_team: parseInt(t[j].bg_team.id),
                            fk_season: parseInt(this.$store.state.currentSeason.id),
                            fk_competition: parseInt(sc[i]),
                            fk_betgame: this.$store.state.betgameId
                          }
                          data.push(d)
                        }
                      }
                    }
                    this.$store.dispatch('saveBetgameTeamCompetitions', data).then(response => {
                      if (response.status >= 200 && response.status <= 204) {
                        this.$store.dispatch('clearSelectedTeams', {}).then(() => {
                          this.$store.dispatch('clearSelectedTeamsCompetitions', {}).then(() => {
                            this.$store.dispatch('clearSelectedCompetitions', {}).then(() => {
                            })
                          })
                        })
                      }
                    }, error => {
                    })
                  }
                  this.$store.dispatch('switchBetgame', this.$store.state.betgameId).then(() => {
                    //this.$store.dispatch('fetchBetgame', this.$store.state.betgameId).then(() => {
                    this.$router.push('/betgameedit')
                    //})
                  })
                }).catch(function(error) {
                  alert(this.$t('errors.betgame_save_failed') + ' ' + error.toString())
                })
              } else {
                window.localStorage.setItem('betgameAction', '')
                window.location.href = 'https://teamtip.net/mybetgames'
              }
            })
          } else {
            var r = confirm(this.$i18n.t('register.change_login_type', {email: email, type: 'Google'}))
            if (r === true) {
              window.localStorage.setItem('betgameAction', '')
              this.$store.dispatch('resetExternalLogin', {
                email: email,
                pass: pwd,
                external_id: eid,
                external_login: 'google'
              }).then(() => {
                //this.$router.push({ name: 'dashboard' })
                window.location.href = 'https://teamtip.net/feed/dashboard'
              }).catch(function (error) {
                Vue.$toast.open({ message: error.toString(), position: 'top', duration: 2 * TOAST_DURATION, type: 'error' })
              })
            } else {
              window.localStorage.setItem('betgameAction', '')
              window.location.href = 'https://teamtip.net/login'
            }
          }
        })
      },
      onLoginSuccess_old (user) {
        Vue.$log.debug('GoogleAuth onLoginSuccess: ', user.email, user.sub, user.name)
        const eid = user.sub
        const email = user.email
        const pwd = eid.slice(1, -1)
        Vue.$log.debug('GoogleAuth mounted ' + ' --- ' + eid + ' --- ' + email)
        APIService.isEmailRegisteredExternal(email.toLowerCase().trim()).then(response => {
          if (response.data.valid === '1') {
            this.$store.dispatch('login', {
              email: String(email).toLowerCase(),
              pass: pwd
            }).then((res) => {
              Vue.$log.debug('GoogleAuth onLoginSuccess ' + JSON.stringify(this.$store.state.user))
              if(this.$store.state.betgame) {
                this.$router.push('/mybetgames')
              } else {
                if(res && (res > 0 || parseInt(res) > 0)) {
                  this.$store.dispatch('switchBetgame', res).then(() => {
                    this.$router.push('/feed/dashboard')
                  })
                } else {
                  this.$router.push('/searchbetgame')
                }
              }
            })
          } else {
            var r = confirm(this.$i18n.t('register.change_login_type', {email: email, type: 'Google'}))
            if (r === true) {
              window.localStorage.setItem('betgameAction', '')
              this.$store.dispatch('resetExternalLogin', {
                email: email,
                pass: pwd,
                external_id: eid,
                external_login: 'google'
              }).then(() => {
                //this.$router.push({ name: 'dashboard' })
                window.location.href = 'https://teamtip.net/feed/dashboard'
              }).catch(function (error) {
                Vue.$toast.open({ message: error.toString(), position: 'top', duration: 2 * TOAST_DURATION, type: 'error' })
              })
            } else {
              window.localStorage.setItem('betgameAction', '')
              window.location.href = 'https://teamtip.net/login'
            }
          }
        })
      },
      async verifyTokenWithBackend(token, id) {
        Vue.$log.debug("GoogleAuth verifyTokenWithBackend: " + id + '  -----  ' +  token)
        const clienttype = this.getGoogleClientType()
        const res = await fetch('https://teamtip.net/auth/google', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: new URLSearchParams({
            credential: token,
            clienttype: clienttype,
          }),
          redirect: 'follow'
        })

        // applesignin.go redirects to /applesignin?... on email_already_used
        if (res.redirected && res.url && res.url.indexOf('/applesignin') !== -1) {
          return { redirected: true, url: res.url }
        }

        const text = await res.text()
        if (id === 1) {
          this.garestext = text
        } else {
          this.restext = text
        }

        if (!res.ok) {
          throw new Error(text || 'Google auth failed')
        }

        var json = null
        try {
          json = JSON.parse(text)
        } catch (e) {
          json = null
        }
        return { redirected: false, json: json, text: text }
      },
      parseJwt(token) {
        try {
          const base64Url = token.split('.')[1]
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
          return JSON.parse(decodeURIComponent(escape(window.atob(base64))))
        } catch (e) {
          Vue.$log.debug("GoogleAuth JWT parse error", e)
          return null
        }
      },
      goBack () {
        if (this.$store.getters.loggedIn) {
          this.$router.push({ name: 'profile' }).catch(err => {
          })
        } else {
          this.$router.push({ name: 'home' })
        }
      }
    }
  }
  
</script>

<style lang="scss" scoped>
</style>
